import api from './api'
import type { CalculationScenario } from '../../../shared/workforceCalculators.mjs'

export type ContactFormPayload = {
  name: string
  email: string
  company?: string
  phone?: string
  message: string
  source?: string
  campaign?: string
  referralCode?: string
  contactWebsite?: string
}

export async function submitContactRequest(payload: ContactFormPayload) {
  const response = await fetch('/api/leads', {
    method: 'POST',
    credentials: 'omit',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      ...payload,
      company: payload.company?.trim() || undefined,
      companyName: payload.company?.trim() || undefined,
      contactName: payload.name,
      source: payload.source || 'contact_sales',
    }),
  })
  if (!response.ok) throw new Error('Unable to submit contact request.')
}

export type DemoRequestPayload = {
  company: string
  contact: string
  email: string
  workers: number
  locations: number
  industry?: string
  source?: string
  campaign?: string
  referralCode?: string
}

export async function submitDemoRequest(payload: DemoRequestPayload) {
  await api.post('/api/demo-request', payload)
}

export type RoiReportPayload = {
  publicCalculationSubmissionId?: string
  calculationSummaries?: CalculationScenario[]
  commercialFollowUpConsent?: boolean
  company: string
  contact: string
  email: string
  workers: number
  locations: number
  industry?: string
  estimatedSavings: number
  estimatedArr?: number
  pricingRecommendation?: string
  source?: string
  campaign?: string
  referralCode?: string
}

export async function submitRoiReport(payload: RoiReportPayload) {
  if (payload.calculationSummaries) {
    const response=await fetch('/api/roi-report',{method:'POST',credentials:'omit',headers:{'content-type':'application/json'},body:JSON.stringify(payload)})
    if(!response.ok)throw new Error('Unable to submit report request.')
    return
  }
  await api.post('/api/roi-report', payload)
}

export function currentLeadAttribution() {
  if (typeof window === 'undefined') return {}
  const params = new URLSearchParams(window.location.search)
  return {
    referralCode: params.get('ref') || params.get('partner') || params.get('invite') || undefined,
    campaign: params.get('utm_campaign') || params.get('campaign') || undefined,
    source: params.get('utm_source') || params.get('source') || undefined,
  }
}
